'use client';

import { bunja } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import { Atom, atom } from 'jotai';
import { createContext } from 'react';

import { Mission } from '@flipster/apis/v1/campaign/types';

export interface MissionTask {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  badge?: string | null;
  button?: { text: string; web: string; app?: string } | null;
}

export interface MissionGroup {
  id: string;
  title?: string | null;
  icon?: { url?: string | null } | null;
  tasks: MissionTask[];
}

export interface MissionsDataSource {
  slug: string;
  eventLocation: string;
  groups: MissionGroup[];
  missionsAtom: Atom<Record<string, Mission> | null>;
  showUpdatedTime?: boolean;
}

export const MissionsDataSourceContext = createContext<MissionsDataSource | null>(null);
export const MissionsDataSourceScope = createScopeFromContext(MissionsDataSourceContext);

export const missionsBunja = bunja(() => {
  const dataSource = bunja.use(MissionsDataSourceScope);

  if (!dataSource) {
    return {
      slug: null,
      eventLocation: null,
      groups: [],
      missionsAtom: atom(() => null),
      showUpdatedTime: false,
      hasMultipleGroups: false,
    };
  }

  const { slug, eventLocation, groups, missionsAtom, showUpdatedTime } = dataSource;

  const hasMultipleGroups = groups.length > 1;

  return {
    slug,
    eventLocation,
    groups,
    missionsAtom,
    showUpdatedTime: showUpdatedTime ?? false,
    hasMultipleGroups,
  };
});
